import { translate } from '@openclassrooms/translations';
import { isCurrentPath } from '@openclassrooms/routing';
import { getLocalisationConfig } from '@openclassrooms/localisation/services';
import { getButtonLinkProps } from '@openclassrooms/routing';

import Button from '@classify/react-core-components/Button';

import mainNavigation from '../../services/mainNavigation';

import HeaderDropDown from './HeaderDropDown';
import HeaderDropDownGroup from './HeaderDropDown/HeaderDropDownGroup';
import HeaderDropDownOverTitle from './HeaderDropDown/HeaderDropDownOverTitle';

interface Props {
  name: string;
  onClick?: () => void;
}

const noop = () => {};

const BusinessDropDownMenu = ({ name, onClick = noop }: Props) => {
  const navigationConfig = mainNavigation();

  return (
    <HeaderDropDown
      name={name}
      title={
        <HeaderDropDown.Title
          title={translate('main_header.business_products.dropdown.title')}
          subTitle={translate('main_header.business_products.dropdown.text')}
        >
          <Button
            variant="secondary"
            {...getButtonLinkProps(navigationConfig.BUSINESS_DISCOVER.path)}
            data-event={navigationConfig.BUSINESS_DISCOVER.dataEvent}
            onClick={onClick}
          >
            {navigationConfig.BUSINESS_DISCOVER.content}
          </Button>
        </HeaderDropDown.Title>
      }
      items={[
        <HeaderDropDownGroup>
          <HeaderDropDownOverTitle
            title={{ content: translate('business.main.header.upskill_reskill'), index: 0 }}
          />
          <HeaderDropDown.Item
            onClick={onClick}
            path={navigationConfig.SPARK.path}
            subTitle={translate('main_header.business_products.dropdown.spark.description')}
            isActive={isCurrentPath(navigationConfig.SPARK.path)}
            data-event={navigationConfig.SPARK.dataEvent}
          >
            {translate('main_header.business_products.dropdown.spark.title')}
          </HeaderDropDown.Item>
          <HeaderDropDown.Item
            onClick={onClick}
            path={navigationConfig.BOOST.path}
            subTitle={translate('main_header.business_products.dropdown.boos.description')}
            isActive={isCurrentPath(navigationConfig.BOOST.path)}
            data-event={navigationConfig.BOOST.dataEvent}
          >
            {translate('main_header.business_products.dropdown.boost.title')}
          </HeaderDropDown.Item>
          <HeaderDropDown.Item
            onClick={onClick}
            path={navigationConfig.PIVOT.path}
            subTitle={translate('main_header.business_products.dropdown.pivot.description')}
            isActive={isCurrentPath(navigationConfig.PIVOT.path)}
            data-event={navigationConfig.PIVOT.dataEvent}
          >
            {translate('main_header.business_products.dropdown.pivot.title')}
          </HeaderDropDown.Item>
        </HeaderDropDownGroup>,
        ...(getLocalisationConfig('page.uplift.url')
          ? [
              <HeaderDropDownGroup>
                <HeaderDropDownOverTitle
                  title={{
                    content: translate('main_header.business_products.dropdown.hire.tagline'),
                    index: 1,
                  }}
                />
                <HeaderDropDown.Item
                  onClick={onClick}
                  path={navigationConfig.UPLIFT.path}
                  subTitle={translate('main_header.business_products.dropdown.uplift.description')}
                  isActive={isCurrentPath(navigationConfig.UPLIFT.path)}
                  data-event={navigationConfig.UPLIFT.dataEvent}
                >
                  {translate('main_header.business_products.dropdown.uplift.title')}
                </HeaderDropDown.Item>
                {getLocalisationConfig('apprenticeship.hasTalentPool') && (
                  <HeaderDropDown.Item
                    onClick={onClick}
                    path={navigationConfig.FINALIZE_APPRENTICESHIP.path}
                    subTitle={translate(
                      'main_header.apprenticeship_dropdown.business_finalize.text'
                    )}
                    isActive={isCurrentPath(navigationConfig.FINALIZE_APPRENTICESHIP.path)}
                    data-event={navigationConfig.FINALIZE_APPRENTICESHIP.dataEvent}
                  >
                    {translate('main_header.apprenticeship_dropdown.business_finalize.title')}
                  </HeaderDropDown.Item>
                )}
              </HeaderDropDownGroup>,
            ]
          : []),
      ]}
    />
  );
};

export default BusinessDropDownMenu;
